import { createSlice } from "@reduxjs/toolkit";

export interface MenuState {
  sectionOpened: string | null;
  isOffcanvas: boolean;
}

const initialState: MenuState = {
  sectionOpened: null,
  isOffcanvas: true,
};

const menuSlice = createSlice({
  name: "menu",
  initialState,
  reducers: {
    setSectionOpened: (state, { payload }: { payload: string | null }) => {
      state.sectionOpened = payload;
    },
    setIsOffcanvas: (state, { payload }: { payload: boolean }) => {
      state.isOffcanvas = payload;
    },
  },
});

export const actions = menuSlice.actions;
export const selectors = menuSlice.selectors;

export default menuSlice;
